module.exports = __webpack_public_path__ + "img/webinars-1.23e0390c.png";